import { useEffect, useState } from "react";
import { tg } from "@/lib/telegram";

/**
 * Верхній safe-area inset для fullscreen-режиму Telegram (Bot API 8.0+).
 * У fullscreen Telegram малює overlay-кнопки (Закрити / Профіль / ···) які
 * перекривають верх контенту. Telegram дає ДВА інсети зверху:
 *   - safeAreaInset.top         — системний (челка / статус-бар пристрою)
 *   - contentSafeAreaInset.top  — місце під кнопками Telegram, відлічується
 *                                 ВІД safe-area (тобто ДОДАТКОВО до неї)
 *
 * Щоб контент опинився НИЖЧЕ обох зон — їх треба ДОДАВАТИ, а не брати max
 * (юзер 2026-06-10: «лого і кнопка назад під кнопками телеграму» — корінь:
 * раніше тут стояв Math.max і недобирав висоту; на сторінках де кнопка
 * справа (Назад/Меню) вона лізла під ✕/··· Telegram). Прибрали костильні
 * floor'и (max(topInset+12,64/118)) у standalone-хедерах — тепер інсет
 * правильний сам по собі.
 *
 * Single source of truth: і Layout, і standalone-сторінки мають однаковий
 * верхній відступ → логотип/хедер в одному місці на КОЖНІЙ сторінці.
 */
export function useTopInset(): number {
  const [topInset, setTopInset] = useState<number>(0);
  useEffect(() => {
    const webapp = tg() as any;
    if (!webapp) return;
    const read = () => {
      const csai = webapp.contentSafeAreaInset?.top;
      const sai = webapp.safeAreaInset?.top;
      const safe = typeof sai === "number" ? sai : 0;
      const content = typeof csai === "number" ? csai : 0;
      // Адитивно: системний інсет + інсет під кнопками Telegram.
      setTopInset(safe + content);
    };
    read();
    try {
      webapp.onEvent?.("safeAreaChanged", read);
      webapp.onEvent?.("contentSafeAreaChanged", read);
      webapp.onEvent?.("fullscreenChanged", read);
    } catch {
      /* старі клієнти */
    }
    return () => {
      try {
        webapp.offEvent?.("safeAreaChanged", read);
        webapp.offEvent?.("contentSafeAreaChanged", read);
        webapp.offEvent?.("fullscreenChanged", read);
      } catch {
        /* ignore */
      }
    };
  }, []);
  return topInset;
}

/**
 * Нижній safe-area inset (Telegram JS). На Android системні кнопки
 * навігації НЕ потрапляють у CSS env(safe-area-inset-bottom) у webview
 * (=0), тому поле вводу перекривається (юзер 2026-06-11). Telegram дає
 * їх через safeAreaInset.bottom (+ contentSafeAreaInset.bottom). Адитивно,
 * як і зверху.
 */
export function useBottomInset(): number {
  const [bottomInset, setBottomInset] = useState<number>(0);
  useEffect(() => {
    const webapp = tg() as any;
    if (!webapp) return;
    const read = () => {
      const csai = webapp.contentSafeAreaInset?.bottom;
      const sai = webapp.safeAreaInset?.bottom;
      const safe = typeof sai === "number" ? sai : 0;
      const content = typeof csai === "number" ? csai : 0;
      setBottomInset(safe + content);
    };
    read();
    try {
      webapp.onEvent?.("safeAreaChanged", read);
      webapp.onEvent?.("contentSafeAreaChanged", read);
      webapp.onEvent?.("fullscreenChanged", read);
    } catch {
      /* старі клієнти */
    }
    return () => {
      try {
        webapp.offEvent?.("safeAreaChanged", read);
        webapp.offEvent?.("contentSafeAreaChanged", read);
        webapp.offEvent?.("fullscreenChanged", read);
      } catch {
        /* ignore */
      }
    };
  }, []);
  return bottomInset;
}
